// extracted by mini-css-extract-plugin
export default {"container":"Br-z","brandName":"Cr-z","productName":"Dr-z","productNamePdpEnhancements":"Er-z","breakLongProductName":"Fr-z"};